import { Box, Flex } from '@televet/kibble-ui';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import { PetAvatar } from 'shared/components/Avatars';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';
import { ModuleName, useModularity } from 'shared/hooks/useModularity';
import { GetAppointmentAiRecapInfoQuery } from 'shared/types/graphql';
import { formatToFriendlyDateTime } from 'shared/utils/formatDate';

export interface AppointmentSummaryProps {
  appointmentData?: GetAppointmentAiRecapInfoQuery['findUniqueAppointment'];
}

const AppointmentSummary = ({ appointmentData }: AppointmentSummaryProps): JSX.Element => {
  const { viewClinicPet, setCurrentClinicPetParentId } = useSidePanelSearch();
  const { hasModule } = useModularity();
  const isStandardClinic = hasModule(ModuleName.AppointmentsStandard);

  return (
    <Box>
      <Heading size="sm" mb={4}>
        Appointment Details
      </Heading>
      <Flex gap={2} mb={4}>
        <PetAvatar
          size="md"
          isActive={!!appointmentData?.clinicPet?.isActive}
          isDeceased={!!appointmentData?.clinicPet?.computedIsDeceased}
          speciesType={appointmentData?.clinicPet?.speciesType}
          hideRightMargin
          onClick={(): void => {
            if (isStandardClinic) {
              setCurrentClinicPetParentId('');
              viewClinicPet({ clinicPetId: appointmentData?.clinicPet?.id || '' });
            }
          }}
        />
        <Box>
          <Text size="sm" fontWeight="bold" as="p">
            {appointmentData?.clinicPet?.name}
          </Text>
          <Text size="xs" as="p">
            {appointmentData?.clinicPetParents?.[0]?.firstName} {appointmentData?.clinicPetParents?.[0]?.lastName}
          </Text>
        </Box>
      </Flex>
      <Flex direction="column" gap={1}>
        <Flex gap={2} mb={2}>
          <Icon name="clock" color="text.subtle" size="md" />
          <Text size="sm">{appointmentData?.startAt ? formatToFriendlyDateTime(appointmentData.startAt) : ''}</Text>
        </Flex>
        <Flex gap={2}>
          <Icon name="calendarCheck" color="text.subtle" size="md" />
          <Text size="sm">{appointmentData?.appointmentType?.name}</Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default AppointmentSummary;
